import { styled } from '@clickcease/cc-client-components-lib'

export const InvoiceTableStyled = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  color: '$mainTextColor',
})

const gridTable = {
  display: 'grid',
  gridTemplateColumns: 'repeat(4, 1fr)',
  height: '50px',
  lineHeight: '50px',
  padding: '0px 30px 0px $8',
}

export const InvoiceTableHeader = styled('div', {
  ...gridTable,
  borderBottom: '1.5px solid #CACACA',
})

export const InvoiceTableHeaderText = styled('div', {
  ['button']: {
    padding: '0px',
  },

  ['svg']: {
    margin: '$1 0px 0px $3',
  },
})

export const InvoiceTableRow = styled('div', {
  ...gridTable,
  borderBottom: '0.5px solid #CACACA',
})

export const InvoiceTableCell = styled('div', {
  fontWeight: '$l',
  variants: {
    status: {
      true: {
        display: 'flex',
        justifyContent: 'space-between',
      },
    },
  },
})

export const StatusText = styled('div', {
  marginLeft: '$2',

  variants: {
    pending: {
      true: {
        color: '$info',
      },
    },
    succeeded: {
      true: {
        color: '$success',
      },
    },
    failed: {
      true: {
        color: '$warning',
      },
    },
  },
})

export const StatusWrapper = styled('div', {
  display: 'flex',

  ['svg']: {
    marginRight: '0',
  },
})
